
import { Icon, InlineIcon } from "@iconify/vue";
import openMenuIcon from "@iconify-icons/ant-design/menu-fold-outlined";
import closeMenuIcon from "@iconify-icons/ant-design/menu-unfold-outlined";
import flagIcon from "@iconify-icons/dashicons/flag";

import { defineComponent } from "vue";
import Sidebar from "@/components/Sidebar.vue";
import Modal from "@/components/Modal.vue";
import { mapActions, mapGetters, mapState } from "vuex";

import { AppState } from "@/store/app";

import { HostingService, HostingStatusType } from "@/services/hosting.service";
import { ModalName } from "./store/ui";

export default defineComponent({
  name: "App",
  data: function() {
    return {
      HostingStatusType: HostingStatusType,
      showing: false,
      icons: {
        flag: flagIcon,
        openMenu: openMenuIcon,
        closeMenu: closeMenuIcon,
      },
      fetchInterval: null as null | NodeJS.Timeout,
      lastInteraction: Date.now(),
    };
  },
  created() {
    this.fetchInterval = setInterval(this.synchronize, 30000);
    this.synchronize();

    document.addEventListener("click", this.resetTimer);

    document.addEventListener("mousemove", this.resetTimer);

    document.addEventListener("scroll", this.resetTimer);

    document.addEventListener("keypress", this.resetTimer);
  },
  unmounted() {
    if (this.fetchInterval) {
      clearInterval(this.fetchInterval);
    }
  },
  computed: {
    ...mapState("app", ["hosting"]),
    ...mapState("ui", ["sidebarShowing"]),
    ...mapGetters("app", ["configIsValid", "dataHasChanged"]),
  },
  methods: {
    ...mapActions("ui", ["toggleSidebarShowing"]),
    resetTimer() {
      this.lastInteraction = Date.now();
    },
    publishChanges() {
      const appState = (this.$store as any).state.app as AppState;
      const payload = HostingService.formatPayloadFromState(appState);
      HostingService.upload(payload, appState.hosting);
      this.$store.dispatch("app/setExistingFeatures", payload);
    },
    async synchronize() {
      const isValid = this.$store.getters["app/configIsValid"]();

      if (Date.now() > this.lastInteraction + 600_000) {
        this.$store.dispatch("ui/setCurrentModal", ModalName.InactivityWarning);
        this.$store.dispatch("ui/setModalShowing", true);
      } else if (isValid) {
        const result = await (HostingService.fetchExistingFeatures(
          (this.$store.state as any).app.hosting
        ) as any);
        console.log({ result });

        this.$store.dispatch("app/setExistingFeatures", result.data);
      }
    },
  },
  components: {
    Sidebar,
    Icon,
    Modal,
  },
});
